export const SUB_STATUS_OPTIONS = {
  messaged_in_application: {
    sub_status_name: 'messaged_in_app',
    text: 'Messaged in Application',
    sub_status_short_description: 'Messaged in Application',
  },
  reached_out_emailed_voicemail_etc: {
    sub_status_name: 'emailed',
    text: 'Reached Out (Emailed, Voicemail, etc)',
    sub_status_short_description: 'Reached Out Email or Msg',
  },
  calling_back_later_either_party: {
    sub_status_name: 'call_back',
    text: 'Calling Back Later (Either Party)',
    sub_status_short_description: 'Calling Back Later',
  },
  no_answer_from_customer: {
    sub_status_name: 'did_not_answer',
    text: 'No Answer from Customer',
    sub_status_short_description: 'No Answer from Customer',
  },
  follow_up_quote_scheduling_etc: {
    sub_status_name: 'follow_up',
    text: 'Follow-up (Quote, Scheduling, etc)',
    sub_status_short_description: 'Follow-up',
  },
  contact_info_was_incorrect_invalid_phone_number_or_email: {
    sub_status_name: 'invalid_phone_number',
    text: 'Contact Info was Incorrect (Invalid Phone Number or Email)',
    sub_status_short_description: 'Contact Info was Incorrect',
  },
  customer_not_interested_hired_another_pro_did_work_themselves_etc: {
    sub_status_name: 'not_interested',
    text: 'Customer Not Interested (Hired Another Pro, Did Work Themselves, etc)',
    sub_status_short_description: 'Customer Not Interested',
  },
  i_don_t_provide_that_service_area: {
    sub_status_name: 'lead_submitted_in_error',
    text: 'I Don’t Provide That Service/Area',
    sub_status_short_description: 'Don’t Provide That Service/Area',
  },
  did_not_call_customer_yet: {
    sub_status_name: 'did_not_call_yet',
    text: 'Did Not Call Customer Yet',
    sub_status_short_description: 'Did Not Call Customer Yet',
  },
  customer_deciding: {
    sub_status_name: 'undecided',
    text: 'Customer Deciding',
    sub_status_short_description: 'Customer Deciding',
  },
  spoke_to_customer: {
    sub_status_name: 'spoke_to_customer',
    text: 'Spoke to Customer',
    sub_status_short_description: 'Spoke to Customer',
  },
  selected_show_number: {
    sub_status_name: 'selected_show_number',
    text: 'Selected Show Number',
    sub_status_short_description: 'Selected Show Number',
  },
  reached_out_awaiting_follow_up: {
    sub_status_name: 'reached_out_awaiting_follow_up',
    text: 'Reached out. Awaiting follow-up, scheduling, decision, or call back',
    sub_status_short_description: 'Reached Out, Awaiting Follow-up',
  },
  customer_not_called_no_answer: {
    sub_status_name: 'customer_not_called_no_answer',
    text: 'Customer Not Called / No Answer',
    sub_status_short_description: 'Customer Not Called / No Answer',
  },
  select_status: {
    sub_status_name: 'select_status',
    text: 'Select Status',
    sub_status_short_description: 'Select Status',
  },
  other: {
    sub_status_name: 'other',
    text: 'Other',
    sub_status_short_description: 'Other',
  },
};

export const SUB_STATUS_LABELS = {
  SPOKE_TO_CUSTOMER: 'spoke_to_customer',
  REACHED_OUT: 'emailed',
  DID_NOT_CALL_YET: 'did_not_call_yet',
  CUSTOMER_DECIDING: 'undecided',
  SELECTED_SHOW_NUMBER: 'selected_show_number',
  MESSAGED_IN_APP: 'messaged_in_app',
  FOLLOW_UP: 'follow_up',
  OTHER: 'other',
  I_DONT_PROVIDE_THAT_SERVICE_AREA: 'lead_submitted_in_error',
  CUSTOMER_NOT_INTERESTED: 'not_interested',
  CALLING_BACK_LATER: 'call_back',
  CONTACT_INTO_WAS_INCORRECT: 'invalid_phone_number',
  DID_NOT_ANSWER: 'did_not_answer',
  REACHED_OUT_AWAITING_FOLLOW_UP: 'reached_out_awaiting_follow_up',
  CUSTOMER_NOT_CALLED_NO_ANSWER: 'customer_not_called_no_answer',
};
const {
  SPOKE_TO_CUSTOMER,
  CONTACT_INTO_WAS_INCORRECT,
  CUSTOMER_NOT_INTERESTED,
  I_DONT_PROVIDE_THAT_SERVICE_AREA,
  MESSAGED_IN_APP,
  REACHED_OUT_AWAITING_FOLLOW_UP,
  CUSTOMER_NOT_CALLED_NO_ANSWER,
} = SUB_STATUS_LABELS;

// Legacy statuses (reached out, calling back later, follow-up, customer deciding,
// no answer, did not call yet) are intentionally excluded from the dropdown.
export const SUB_STATUS_OPTIONS_UPDATE = [
  SPOKE_TO_CUSTOMER,
  REACHED_OUT_AWAITING_FOLLOW_UP,
  CUSTOMER_NOT_CALLED_NO_ANSWER,
  CONTACT_INTO_WAS_INCORRECT,
  CUSTOMER_NOT_INTERESTED,
  I_DONT_PROVIDE_THAT_SERVICE_AREA,
  MESSAGED_IN_APP,
];
